import { QueryCache, QueryClient } from '@tanstack/react-query';

import { HttpErrorMessage } from '@api/ApiUtils';
import { alertMessage } from '@utils/common';

// Single app-wide QueryClient instance, provided to the tree via QueryClientProvider in
// pages/_app.tsx (the only importer). Kept in its own module rather than inlined there so the
// instance (and its shared QueryCache error handling) stays independently importable if a
// non-hook call site needs it later — but nothing should import it directly today. Components
// that need the client should call useQueryClient() instead: importing this singleton bypasses
// QueryClientProvider, which silently breaks tests that render against a different (mocked)
// client than the one this module touches.
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.showErrorFromResponse) {
        const errorMessage = HttpErrorMessage(error);
        alertMessage(errorMessage, 'error', 6);
      }
      if (query.meta?.errorMessage) {
        alertMessage(query.meta.errorMessage, 'error', 6);
      }
    },
  }),
});
